import { Component } from '@angular/core';

@Component({
  selector: 'app-s-default',
  templateUrl: './s-default.component.html',
  styleUrls: ['./s-default.component.scss']
})
export class SDefaultComponent {

}
